import React from 'react';
import { Check } from 'lucide-react';

/**
 * v2 sub-step segmented pills (TASK-106) — the Context → Validation →
 * Discovery strip under step-3 page titles, ported from the Step 3a/3b/3c
 * mocks: active = filled cobalt "N · Label", done = success pill with check,
 * upcoming = white outline. Presentational; pages own navigation.
 */
export type SubStepPillState = 'done' | 'active' | 'upcoming';

export interface SubStepPill {
  id: string;
  label: string;
  state: SubStepPillState;
}

export interface SubStepPillsProps {
  items: SubStepPill[];
  onSelect?: (id: string) => void;
  className?: string;
}

export const SubStepPills: React.FC<SubStepPillsProps> = ({ items, onSelect, className = '' }) => (
  <div className={`flex items-center gap-s2 ${className}`}>
    {items.map((item, i) => (
      <React.Fragment key={item.id}>
        {i > 0 && <span className="h-px w-s4 bg-line-strong" />}
        {item.state === 'active' ? (
          <span aria-current="step" className="rounded-round border border-action bg-action px-s4 py-[3px] text-[11px] font-semibold text-white">
            {i + 1} · {item.label}
          </span>
        ) : item.state === 'done' ? (
          <button
            type="button"
            onClick={() => onSelect?.(item.id)}
            className="inline-flex items-center gap-[5px] rounded-round border border-success-border bg-success-bg px-s4 py-[3px] text-[11px] font-semibold text-success-ink"
          >
            <Check className="h-[10px] w-[10px]" />
            {item.label}
          </button>
        ) : (
          <button
            type="button"
            onClick={() => onSelect?.(item.id)}
            className="rounded-round border border-line bg-surface px-s4 py-[3px] text-[11px] font-semibold text-ink-muted"
          >
            {item.label}
          </button>
        )}
      </React.Fragment>
    ))}
  </div>
);

export default SubStepPills;
